module.exports = __webpack_public_path__ + "static/assets/31a6dcded6dfe16288e0104dc10aa605.gif";